export function formatVndAmount(value?: number | null): string {
  if (value == null || !Number.isFinite(value)) return '-';
  return `${value.toLocaleString('vi-VN')} VNĐ`;
}

export function formatVndInput(value: string | number): string {
  const raw = String(value ?? '').replace(/\D/g, '');
  if (!raw) return '';
  return Number(raw).toLocaleString('vi-VN');
}

export function parseVndInput(value: string): number | undefined {
  const raw = value.replace(/\./g, '').trim();
  if (!raw) return undefined;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : undefined;
}
